import store from 'store2';
import { parseCookies, setCookie } from 'nookies';
import { NextPageContext } from 'next/dist/next-server/lib/utils';
import { GetServerSidePropsContext } from 'next';
import { ParsedUrlQuery } from 'querystring';
import * as Sentry from '@sentry/browser';

export const localStorage = typeof window !== 'undefined' ? store.local : null;
export const sessionStorage = store.session;

export interface CookieStorage {
  grx_unique_id?: string;
  ajs_anonymous_id?: string;
  isTesting?: boolean;
  optimizelyId?: string;
  queryParams?: {
    partner?: string;
    pharmacyId?: string | number;
    promoCode?: string;
    utm_source?: string;
  };
  utmMedium?: string;
  utmSource?: string;
}

export type CtxContext = NextPageContext | GetServerSidePropsContext<ParsedUrlQuery>;

export const cookies = {
  get: (ctx?: CtxContext): CookieStorage => parseCookies(ctx, { decode: JSON.parse }),
  set: <K extends keyof CookieStorage>(name: K, value: CookieStorage[K], ctx?: CtxContext) => {
    try {
      setCookie(ctx, name, value as string, {
        encode: (v: string | Record<string, unknown>) => (typeof v === 'string' ? v : JSON.stringify(v)),
        path: '/',
      });
    } catch (e) {
      Sentry.captureException(e);
    }
  },
};
